import React, { useState } from 'react'

import * as R from 'ramda'

import { Button, Flex, Header, Text } from '@driftt/dds'
import { ModalBody, ModalFooter, useCloseModal } from '@driftt/tide-modal'

import { isFirstStep, isLastStep } from './FirstExperienceModal.helpers'
import {
  FirstExperienceContentBody,
  FirstExperienceContentImageContainer,
} from './FirstExperienceModal.styles'
import type { FirstExperienceContentProps } from './FirstExperienceModal.types'

export const FirstExperienceContent = ({
  steps = [],
}: FirstExperienceContentProps) => {
  const handleClose = useCloseModal()

  const [stepIndex, setStepIndex] = useState(0)

  const { header, description, imageProps } = steps[stepIndex]
  const { src, alt } = imageProps

  const handleBack = () => setStepIndex(R.dec)
  const handleNext = () => setStepIndex(R.inc)

  return (
    <>
      <FirstExperienceContentImageContainer justifyContent="center">
        <img src={src} alt={alt} />
      </FirstExperienceContentImageContainer>
      <ModalBody>
        <FirstExperienceContentBody direction="column">
          <Header variant="h3">{header}</Header>
          <Text>{description}</Text>
        </FirstExperienceContentBody>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="space-between">
          <Button
            onClick={handleBack}
            variant="secondary"
            disabled={isFirstStep(stepIndex)}
          >
            Back
          </Button>
          {isLastStep(stepIndex, steps) ? (
            <Button variant="primary" onClick={handleClose}>
              Get started!
            </Button>
          ) : (
            <Button variant="primary" onClick={handleNext}>
              Next
            </Button>
          )}
        </Flex>
      </ModalFooter>
    </>
  )
}
